export default __webpack_public_path__ + "static/media/vol5_3.4e6b0f63.png";